import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, AfterContentInit } from '@angular/core';
import * as L from 'leaflet';

declare var System: any;

@Component({
  selector: 'tx-simple-map',
  templateUrl: './tx-simple-map.component.html',
  styleUrls: ['./tx-simple-map.component.css']
})
export class TxSimpleMapComponent implements OnInit, AfterViewInit {
  mapContainer;

  private _coordinate: any;

  @Input() mapId = Date.now();
  private originalLat = -3.753092453196685;
  private originalLng = -38.52390289306641;
  private originalZoom = 15;
  lat = this.originalLat;
  lng = this.originalLng;
  zoom = this.originalZoom;
  private id = 'mapbox.streets';
  private MAP_URL = 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}';
  private accessToken = 'pk.eyJ1IjoiZ3VzdGF2b2FpcmVzIiwiYSI6ImNqNGhyanNsaDAxbTYyd3M2cGhicndzcDYifQ.gN__JIYsdSHdDCQ0scIo8g';
  private attribution = `Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>
                contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>,
                Imagery © <a href="http://mapbox.com">Mapbox</a>`;
  private icon = null;
  private options = {};
  private map: L.Map;
  private marker: L.Marker;

  constructor(private elRef: ElementRef) {
  }

  ngAfterViewInit() {
    this.getMapContainer();
  }

  get coordinate() {
    return this._coordinate;
  }

  @Input()
  set coordinate(coordinate) {
    this.handleCoordinateInput(coordinate);
  }

  ngOnInit() {
  }

  private handleCoordinateInput(coordinate) {
    this.setLocationData(coordinate);
    if (this.mapContainer) {
      this.plotMap();
      this.updateMapView();
    }
  }

  private setLocationData(coordinate) {
    if (coordinate) {
      this._coordinate = coordinate;
      this.lat = coordinate.latitude;
      this.lng = coordinate.longitude;
    }
  }

  private plotMap() {
    this.handleMapInit();
  }

  private handleMapInit() {
    if (!this.icon) {
      System.import('../../../../assets/marker-icon.png').then(this.setMapMarker);
    } else {
      this.setMapMarker(this.icon);
    }
  }

  private setMapMarker = (file) => {
    if (!this.icon) {
      this.icon = new L.Icon({
        iconUrl: file,
        iconAnchor: [13, 43]
      });
      this.options = { icon: this.icon };
    }
    this.addMapLayers();
  };

  private addMapLayers() {
    if (!this.map) {
      this.createMap();
      this.createMapTileLayer();
    }
    if (this._coordinate) {
      this.updateMapView();
      this.addLocation();
    }
  }

  private createMap() {
    this.map = L.map(this.mapContainer, {
      center: [this.lat, this.lng],
      zoom: this.zoom,
      worldCopyJump: true,
      closePopupOnClick: false,
      attributionControl: false
    });
  }

  private createMapTileLayer() {
    L.tileLayer(this.MAP_URL, {
      accessToken: this.accessToken,
      attribution: this.attribution,
      maxZoom: 18,
      minZoom: 3,
      id: this.id
    }).addTo(this.map);
  }

  private updateMapView() {
    if (this.map) {
      this.map.setView([this.lat, this.lng], this.zoom);
    }
  }

  private addLocation() {
    if (this.map && this._coordinate) {

      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.marker = L.marker([this.lat, this.lng], this.options).addTo(this.map);
    }
  }

  private getMapContainer() {
    const div = this.elRef.nativeElement.querySelector(`#${this.mapId}`);
    this.mapContainer = div;
    if (this.mapContainer) {
      this.handleCoordinateInput(null);
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-simple-map/tx-simple-map.component.ts